<template>
  <div class="pagehead">
    <!--添加到桌面：只有在BC中才显示-->
    <addscreen v-if="userInfo.token && !isNotBuzzCast()"></addscreen>
    <div class="fc-bg-fff fc-pad-lr">
      <!--标题：xxx充值官方网站-->
      <p class="recharge_title">{{ $t('m.Diamonds_title', { msg: getAppName() }) }}</p>
      <div class="fc-pad-r fc-flex fc-flex-vcenter">
        <!--头像-->
        <img class="user_photo avater" :src="userInfo.img || require('../assets/img/h5_recharge_head.png')">
        <div class="fc-flex1 fc-mar-lr-sm">
          <!--昵称/您还没有登录-->
          <p class="fc-text-big fc-elip-1 fc-text-bold" style="max-width: 3rem;" v-cloak>
            {{ userInfo.nickName || $t('m.login_no') }}</p>
          <!--用户id/登录后即可充值-->
          <p class="fc-text-usual fc-mar-t-min" v-cloak v-if="!isInBondo">
            {{ userInfo.userId ? 'ID:' + userInfo.userId : $t('m.login_after_recharge') }}</p>
        </div>
        <!--退出按钮-->
        <div class="fc-btn-line-main" @click="exitLogin" v-if="userInfo.userId">{{ $t('m.logout') }}</div>
        <!--登录按钮-->
        <div class="fc-btn-line-main" @click="enterLogin" v-else>{{ $t('m.login') }}</div>
      </div>
      <!--bondo充值提示:充值余额仅限APP端使用，下载并打开APP，用余额解锁并观看付费剧集-->
      <div class="bondo-pay-tip" v-if="isInBondo">
        {{$t('m.bondo_pay_tip')}}
      </div>
    </div>
  </div>
</template>
<script>
import addscreen from '@/components/addscreen'
import { exitLogin } from "@/tools/common.js";
import {getAppName, isNotBuzzCast} from "../util";
import multiDomain from "../mixins/multiDomain";
export default{
  name:'haeder',
  mixins: [multiDomain],
  components: {
    addscreen
  },
  props: {
      userInfo: {
        type: Object,
        default: function () {
            return {}
        }
      }
  },
  data(){
    return{
      deviceType:'',
    }
  },
  created() {

  },
  methods:{
    isNotBuzzCast,
    getAppName,
    //去登录页
    enterLogin() {
      this.$router.push({
        path: '/login'
      })
    },
    //退出登录
    exitLogin() {
      exitLogin()
    },
  }
}
</script>
<style scoped>

.add_main_screen {
  display: flex;
  align-items: center;
  min-height: .54rem;
  background-color: #D0E9FF;
  font-size: .24rem;
  padding: .15rem;
}

.add_main_screen .txt {
  flex: 1;
  padding: 0 .15rem;
}

.add_main_screen .btn {
  padding: .08rem .2rem;
  /* line-height: 1.3; */
  border-radius: 5rem;
  background-color: #008AFF;
  color: #fff;
  max-width: 2rem;
}
.bondo-pay-tip {
  padding-top: 0.14rem;
  padding-bottom: 0.14rem;
  color: #9497A2;
  font-size: 0.28rem;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/pagehead.vue